import { __module as i } from "./chunk700.js";
var x = i.exports, h;
function _() {
  return h ? i.exports : (h = 1, function(p, w) {
    (function(B, n) {
      p.exports = n();
    })(x, function() {
      return function(B, n, s) {
        n.prototype.isBetween = function(a, c, e, o) {
          var t = s(a), r = s(c), u = (o = o || "()")[0] === "(", f = o[1] === ")";
          return (u ? this.isAfter(t, e) : !this.isBefore(t, e)) && (f ? this.isBefore(r, e) : !this.isAfter(r, e)) || (u ? this.isBefore(t, e) : !this.isAfter(t, e)) && (f ? this.isAfter(r, e) : !this.isBefore(r, e));
        };
      };
    });
  }(i), i.exports);
}
export {
  _ as __require
};
